module.exports = __webpack_public_path__ + "static/img/instagram.e1edeff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integration/instagram.png
// module id = 0BAw
// module chunks = 134